<template>
  <b-modal
    :title="`${
      selectedPriceCategory && selectedPriceCategory.isShow ? 'غیر' : ''
    } فعال سازی گروه‌بندی`"
    id="price-category-toggle-confirmation-modal"
    centered
    ok-title="بله"
    cancelTitle="خیر"
    @ok="changePriceCategoryIsShow"
  >
    <b-container>
      <span v-if="selectedPriceCategory">
        آیا از {{ selectedPriceCategory.isShow ? "غیر" : "" }} فعال سازی
        گروه‌بندی
        <strong>
          {{ selectedPriceCategory.title }}
        </strong>
        با مدت جلسه
        {{ selectedPriceCategory.durationMinute }} دقیقه اطمینان دارید؟
      </span>
    </b-container>
  </b-modal>
</template>
<script>
export default {
  emits: ["refetch"],
  props: {
    selectedPriceCategory: {
      type: [Object, null],
    },
  },
  methods: {
    async changePriceCategoryIsShow() {
      try {
        this.isLoading = true;
        let _this = this;
        let togglePriceCategoryIsShow = new TogglePriceCategoryIsShow(_this);
        togglePriceCategoryIsShow.setRequestParam({
          id: _this.selectedPriceCategory.id,
        });
        await togglePriceCategoryIsShow.fetch((res) => {
          if (res.isSuccess) {
            _this.$toast({
              component: ToastificationContent,
              props: {
                title: "تغییر کرد!",
                icon: "Trash2Icon",
                variant: "success",
                text: "وضعیت گروه‌بندی با موفقیت تغییر کرد.",
              },
            });
            _this.$emit("refetch");
          } else {
            _this.$toast({
              component: ToastificationContent,
              props: {
                title: "تغییر نکرد!",
                icon: "Trash2Icon",
                variant: "danger",
                text: res.errors || "مشکلی پیش آمد، لطفا دوباره امتحان کنید",
              },
            });
          }
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
  },
  components: {
    BModal,
    BContainer,
  },
};
import { BModal, BContainer } from "bootstrap-vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import { TogglePriceCategoryIsShow } from "@/libs/Api/PriceCategory";
</script>
